import { render, staticRenderFns } from "./CustomFieldUrl.vue?vue&type=template&id=68dbf71e"
import script from "./CustomFieldUrl.vue?vue&type=script&lang=js"
export * from "./CustomFieldUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports